var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteunchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2894 11.8009C17.5878 11.5169 17.8531 11.2167 18.1653 10.9739C20.2337 9.36184 23.0706 9.79464 24.6442 11.9497C26.0369 13.8574 25.9387 16.3897 24.399 18.2248C23.5526 19.2338 22.5794 20.1209 21.5548 20.9498C20.3705 21.9095 19.155 22.8333 17.9477 23.7661C17.5575 24.0681 17.0994 24.077 16.7175 23.7966C14.8979 22.4614 13.1048 21.0931 11.4808 19.5313C10.9217 18.9937 10.3754 18.4273 9.9182 17.8082C8.24271 15.5375 8.94045 12.1513 11.3587 10.6531C13.2416 9.48729 15.7755 9.9389 17.2031 11.6961C17.2353 11.7364 17.2683 11.7758 17.2894 11.8009ZM17.3152 13.0716C17.2812 13.0321 17.261 13.0115 17.2435 12.9891C16.9626 12.6334 16.7065 12.2543 16.3971 11.9246C15.1779 10.6271 13.1535 10.3654 11.7259 11.3C9.6235 12.6755 9.11305 15.559 10.6389 17.5313C10.9648 17.9524 11.332 18.3476 11.714 18.7212C13.3858 20.3584 15.2412 21.7858 17.126 23.1774C17.2702 23.284 17.3877 23.2607 17.518 23.1595C18.5904 22.3261 19.6764 21.5107 20.7332 20.6585C21.799 19.7992 22.8227 18.8915 23.7243 17.861C24.6763 16.7723 25.0518 15.5214 24.7791 14.1137C24.5349 12.8538 23.8574 11.8502 22.7144 11.2033C21.1261 10.3036 19.0907 10.7561 17.9642 12.2176C17.7512 12.4945 17.541 12.7741 17.3161 13.0698L17.3152 13.0716Z",
    fill: "white",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteunchecked);
export default __webpack_public_path__ + "static/media/favoriteunchecked.5af96c0b38eee12111b4130d99dd9b67.svg";
export { ForwardRef as ReactComponent };